<template>
  <router-view v-slot="{ Component }">
    <keep-alive>
      <component :is="Component" v-if="route.meta.keepAlive" />
    </keep-alive>
    <component :is="Component" v-if="!route.meta.keepAlive" />
  </router-view>
  <!--  <router-view />-->
</template>
<script setup>
import { useRoute } from "vue-router";
import { localCache } from "@/utils/Cache";
const route = useRoute();
import { onMounted } from "vue";
// 清除浏览器携带的参数
function getNewUrl() {
  let url = document.location.href;
  let reg = /[^\w](code)=?([^&|^#]*)/g;
  url = url.replace(reg, "");
  reg = /&&/g;
  url = url.replace(reg, "");
  reg = /&#/g;
  url = url.replace(reg, "#");
  reg = /\?#/g;
  url = url.replace(reg, "#");
  reg = /\?#/g;
  url = url.replace(reg, "#");
  return url;
}
onMounted(() => {});
</script>
<style lang="scss"></style>
